<script>
  import relatorioServico from '../relatorio.servico';
  import projetoServico from '~modulos/projeto/servico';

  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import 'vue-strap/dist/vue-strap-lang';

  import { radio, datepicker } from 'vue-strap';
  import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';
  import TelaCheia from '~componentes/TelaCheia.vue';
  
  export default {
    components: { datepicker, radio, CabecalhoRelatorio, TelaCheia },
    data() {
      return {
        filtros: {
          idProjeto: '',
          dataInicio: moment(new Date()).format('DD/MM/YYYY'),
          dataFim: moment(new Date()).format('DD/MM/YYYY'),
          idConta: '',
          idRubrica: '',
          idSubrubrica: '',
          idMetaEtapa: '',
          contasPagar: 'true',
          tipo: 0,
        },
        projetos: [],
        contas: [],
        rubricas: [],
        subrubricas: [],
        metaEtapas: [],
        relatorio: [],
        saldoAnterior: 0,
        projeto: null,
        contasPagar: false,
        dataInicio: null,
        dataFim: null,
        rubrica: null, 
        subrubrica: null, 
        metaEtapa: null, 
        conta: null, 
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("RelContasPagarReceber")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      listaContas(idProjeto) {
        return projetoServico
          .contasProjeto(idProjeto)
          .then(contas => {
            this.contas = contas;
          });
      },
      listaDeMetaEtapas() {
        return projetoServico
          .metaEtapasProjeto(this.filtros.idProjeto)
          .then(metaEtapas => {
            this.metaEtapas = metaEtapas;
          });
      },
      listaDeRubricas() {
        return projetoServico
          .rubricasProjeto(this.filtros.idProjeto, this.filtros.idMetaEtapa)
          .then(rubricas => {
            this.rubricas = rubricas;
          });
      },
      listaDeSubrubricas() {
        this.filtros.idSubrubrica = '';
        
        if (this.projetoSelecionado.utilizarMetaEtapaProjeto && this.filtros.idMetaEtapa !== '' && this.filtros.idRubrica === '') {
          this.subrubricas = [];
          return;
        }
        
        return projetoServico
          .subrubricasProjeto(this.filtros.idProjeto, this.filtros.idRubrica, this.filtros.idMetaEtapa)
          .then(subrubricas => {
            this.subrubricas = subrubricas;
          });
      },
      gerar() {
        this.relatorio = [];
        this.setarProjeto();
        this.setarConta();
        this.setarRubrica();
        this.setarSubrubrica();
        this.setarMetaEtapa();
        this.contasPagar = (this.filtros.contasPagar === 'true');
        this.dataInicio = this.filtros.dataInicio;
        this.dataFim = this.filtros.dataFim;
        
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar').button('loading');
            
            return relatorioServico.contasPagarReceber(this.filtros);
          })
          .then(resultado => {
            this.relatorio = resultado.lancamentos;
            this.saldoAnterior = resultado.saldoAnterior;
            this.totalPagoRecebido = resultado.totalPagoRecebido;
            this.totalPagarReceber = resultado.totalPagarReceber;
            this.somaTotais = resultado.somaTotais;
            
            $('#gerar').button('reset');
            
            if (this.relatorio.length === 0) {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              this.$nextTick(() => {
                $('html, body').animate({
                  scrollTop: $('#relatorio').offset().top
                }, 800);
              });
            }
          })
          .catch(erro => {
            $('#gerar').button('reset');

            if (erro.status === 422) {
              this.$mensagemErro(erro, erro.body.message);
            } else {
              this.$mensagemErro(erro, 'Erro ao gerar relatório.');
            }
          });
      },
      gerarExcel() {
        this.relatorio = {};

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");

            $('#gerar-excel').button('loading');

            return relatorioServico.contasPagarReceberExcel(this.filtros)
          })
          .then(arquivo => {
            $('#gerar-excel').button('reset');

            if (arquivo === '') {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              arquivo.download();
            }
          })
          .catch(erro => {
            $('#gerar-excel').button('reset');

            this.$mensagemErro(erro, 'Erro ao gerar relatório.');
          });
      },
      setarProjeto() {
        const idProjeto = this.filtros.idProjeto;

        this.projeto = idProjeto ? this.projetos.find(p => p.idProjeto == idProjeto) : null; 
      },
      setarConta() {
        const idConta = this.filtros.idConta;

        this.conta = idConta ? this.contas.find(c => c.id == idConta) : null; 
      },
      setarRubrica() {
        const idRubrica = this.filtros.idRubrica;

        this.rubrica = idRubrica ? this.rubricas.find(r => r.id == idRubrica) : null; 
      },
      setarSubrubrica() {
        const idSubrubrica = this.filtros.idSubrubrica;

        this.subrubrica = idSubrubrica ? this.subrubricas.find(s => s.id == idSubrubrica) : null; 
      },
      setarMetaEtapa() {
        const idMetaEtapa = this.filtros.idMetaEtapa;

        this.metaEtapa = idMetaEtapa ? this.metaEtapas.find(me => me.idProjetoMetaEtapa == idMetaEtapa) : null; 
      },
      saldoParcial(indiceAtual) {
        return this.saldoAnterior + this.relatorio.reduce((total, lancamento, indice) => {
          if (indice > indiceAtual) {
            return total;
          } else {
            return total + lancamento.valor;
          }
        }, 0);
      }
    },
    computed: {
      projetoSelecionado() {
        const idProjeto = this.filtros.idProjeto;
        
        return idProjeto ? this.projetos.find(projeto => projeto.idProjeto == idProjeto) : {};
      },
    },
    mounted() {
      this.$root.tituloDaPagina = `Relatório de Contas a Pagar e Receber`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.$events.on('botaoAcao', function() {
        window.print();
      });

      this.listaDeProjetos();

      const _this = this;

      //$('.datepicker input').attr('readonly', '');

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
        
        _this.filtros.idMetaEtapa = '';
        _this.filtros.idConta = '';
        _this.filtros.idRubrica = '';
        _this.filtros.idSubrubrica = '';

        if (_this.configuracao.filtrarLancamentoContaCorrenteWeb) {
          _this.listaContas(this.value);
        }
        
        if (_this.projetoSelecionado.utilizarMetaEtapaProjeto) {
          _this.listaDeMetaEtapas();
        }
        
        _this.listaDeRubricas();
        _this.listaDeSubrubricas();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
    <form class="hidden-print" @submit.prevent="gerar">

      <div class="ibox float-e-margins">
        <div class="ibox-content">

          <div class="row">
            <div class="col-xs-6">
              <div class="form-group">
                <radio
                  v-model="filtros.contasPagar"
                  selected-value="true"
                  type="success">
                  Contas a Pagar
                </radio>
              </div>
            </div>

            <div class="col-xs-6">
              <div class="form-group">
                <radio
                  v-model="filtros.contasPagar"
                  selected-value="false"
                  type="success">
                  Contas a Receber
                </radio>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group required" :class="{'has-error': errors.has('dataInicio')}">
                <label class="control-label">Período</label>

                <datepicker
                  id="dataInicio"
                  v-mascara="'data-mask'"
                  v-model="filtros.dataInicio"
                  format="dd/MM/yyyy"
                  placeholder="  /  /     "
                  lang="pt-BR">
                </datepicker>

                <p class="text-danger" v-show="errors.has('dataInicio')">{{ errors.first('dataInicio') }}</p>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group" :class="{'has-error': errors.has('dataFim')}">
                <label class="control-label">&nbsp; &nbsp;</label>

                <datepicker
                  id="dataFim"
                  v-mascara="'data-mask'"
                  v-model="filtros.dataFim"
                  format="dd/MM/yyyy"
                  placeholder="  /  /     "
                  lang="pt-BR">
                </datepicker>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-4">
              <div class="form-group">
                <radio
                  v-model="filtros.tipo"
                  :selected-value="0"
                  type="success">
                  Todas
                </radio>
              </div>
            </div>

            <div class="col-xs-4">
              <div class="form-group">
                <radio
                  v-model="filtros.tipo"
                  :selected-value="1"
                  type="success">
                  Pagas/Baixadas
                </radio>
              </div>
            </div>

            <div class="col-xs-4">
              <div class="form-group">
                <radio
                  v-model="filtros.tipo"
                  :selected-value="2"
                  type="success">
                  Pendentes
                </radio>
              </div>
            </div>
          </div>
          
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group required" :class="{'has-error': errors.has('projeto')}">
                <label class="control-label" for="projeto">Projeto</label>

                <select
                  id="projeto"
                  class="form-control"
                  v-model="filtros.idProjeto"
                  data-vv-name="projeto"
                  v-validate="'required'">
                  <option value="">Selecione...</option>
                  <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
              </div>
            </div>
          </div>

          <div class="row" v-if="configuracao.filtrarLancamentoContaCorrenteWeb">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="conta">Conta</label>

                <select id="conta"
                        class="form-control"
                        v-model="filtros.idConta">
                  <option value="">Selecione...</option>
                  <option :value="conta.idConta" v-for="conta in contas">{{ conta.nomeConta }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row" v-if="projetoSelecionado.utilizarMetaEtapaProjeto">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="metaEtapa">Meta Etapa</label>

                <select id="metaEtapa"
                        class="form-control"
                        v-model="filtros.idMetaEtapa"
                        @change="listaDeRubricas(); listaDeSubrubricas();">
                  <option value="">Selecione...</option>
                  <option :value="metaEtapa.idProjetoMetaEtapa" v-for="metaEtapa in metaEtapas">{{ metaEtapa.meta.nome }} {{ metaEtapa.etapa.nome }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="rubrica">Rubrica</label>

                <select id="rubrica"
                        class="form-control"
                        v-model="filtros.idRubrica"
                        @change="listaDeSubrubricas">
                  <option value="">Selecione...</option>
                  <option :value="rubrica.id" v-for="rubrica in rubricas">{{ rubrica.nome }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="subrubrica">Subrubrica</label>

                <select id="subrubrica"
                        class="form-control"
                        v-model="filtros.idSubrubrica">
                  <option value="">Selecione...</option>
                  <option :value="subrubrica.id" v-for="subrubrica in subrubricas">{{ subrubrica.nome }}</option>
                </select>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <button
              id="gerar"
              type="button"
              class="btn btn-primary"
              @click="gerar"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-line-chart"></i>
              Gerar relatório
            </button>
            <button
              id="gerar-excel"
              type="button"
              class="btn btn-primary"
              @click="gerarExcel"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-table"></i>
              Gerar relatório em excel
            </button>

            <tela-cheia
              texto="Visualizar em tela cheia"
              icone="arrows-alt"
              v-if="relatorio.length > 0">
            </tela-cheia>
          </div>
        </div>
      </div>
    </form>

    <cabecalho-relatorio :titulo="`Relatório de Contas a ${contasPagar ? 'pagar' : 'receber'}`" borda=""></cabecalho-relatorio>

    <div class="row" v-if="relatorio.length > 0" id="relatorio">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            
            <div class="table-responsive">
              <table class="table relatorio table-condensed no-margins">
                <thead>
                  <tr>
                    <th>Projeto</th>
                    <th v-if="conta">Conta</th>
                    <th v-if="metaEtapa">Meta Etapa</th>
                    <th v-if="rubrica">Rubrica</th>
                    <th v-if="subrubrica">Subrubrica</th>
                    <th class="text-right">Período</th>
                    <!--<th class="text-right">Saldo anterior</th>-->
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ projeto.nomeProjeto }}</td>
                    <td v-if="conta">{{ conta.nomeConta }}</td>
                    <td v-if="metaEtapa">{{ metaEtapa.meta.nome }} {{ metaEtapa.etapa.nome }}</td>
                    <td v-if="rubrica">{{ rubrica.nome }}</td>
                    <td v-if="subrubrica">{{ subrubrica.nome }}</td>
                    <td class="text-right">{{ dataInicio }} - {{ dataFim }}</td>
                    <!--<td class="text-right">{{ contasPagar ? '-' : '' }}{{ saldoAnterior | formatarNumero }}</td>-->
                  </tr>
                </tbody>
              </table>

              <br/>

              <table class="table relatorio table-bordered">
                <thead>
                  <tr>
                    <th>Data de vencimento</th>
                    <th>Data de emissão</th>
                    <th>Data pgto.</th>
                    <th>Código</th>
                    <th>Histórico</th>
                    <th>Documento</th>
                    <th class="text-right">Valor (R$)</th>
                    <th class="text-right">Valor {{ contasPagar ? ' pago' : ' recebido' }} (R$)</th>
                    <!--<th class="text-right">Saldo a {{ contasPagar ? ' pagar' : ' receber' }} (R$)</th>-->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(lancamento, indice) in relatorio">
                    <td>{{ lancamento.dataVencimento | formatarData }}</td>
                    <td>{{ lancamento.dataEmissao | formatarData }}</td>
                    <td>{{ lancamento.data | formatarData('---') }}</td>
                    <td>{{  lancamento.idLancamento || '---' }}</td>
                    <td>{{ lancamento.historico }} - {{ lancamento.nomeSubrubrica }} - {{ lancamento.complemento }}</td>
                    <td>{{ lancamento.documento || '---' }}</td>
                    <td class="text-right">{{ contasPagar ? '-' : '' }}{{ lancamento.valor | formatarNumero }}</td>
                    <td class="text-right">{{ contasPagar ? '-' : '' }}{{ lancamento.valorPagoRecebido | formatarNumero }}</td>
                    <!--<td class="text-right">{{ contasPagar ? '-' : '' }}{{ saldoParcial(indice) | formatarNumero }}</td>-->
                  </tr>
                </tbody>
              </table>

              <table class="table relatorio table-condensed no-margins">
                <tbody>
                  <tr>
                    <th class="text-right">Total {{ contasPagar ? ' pago' : ' recebido' }} no período (R$):</th>
                    <td class="text-right">{{ totalPagoRecebido | formatarNumero }}</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <th class="text-right">Total a {{ contasPagar ? ' pagar' : ' receber' }} no período (R$):</th>
                    <td class="text-right">{{ totalPagarReceber | formatarNumero }}</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <th class="text-right">Total (R$):</th>
                    <td class="text-right">{{ somaTotais | formatarNumero }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/ContasPagarReceber.vue